import { deleteRequest } from "./http";
import userServiceApi from "./userServiceApi";
import deletionVerificationService from "./deletionVerificationService";

/**
 * Partner-specific secure deletion service.
 *
 * - sendDeleteOtp → GET /confirm-entity-deletion?entity=PARTNER
 * - verifyDeleteOtp → POST /verify-otp?otp={otp}
 * - deletePartner → existing DELETE /super-admin/partner/{id}
 */
const partnerDeleteService = {
  /**
   * Request OTP before Partner deletion.
   * @param {{ partnerId: string|number, partnerName: string }} params
   */
  sendDeleteOtp({ partnerId, partnerName }) {
    return deletionVerificationService.sendDeleteOtp({
      entity: "PARTNER",
      entityId: partnerId,
      displayName: partnerName,
    });
  },

  /**
   * Verify OTP for Partner deletion.
   * @param {{ partnerId: string|number, otp: string }} params
   */
  verifyDeleteOtp({ partnerId, otp }) {
    return deletionVerificationService.verifyDeleteOtp({
      entity: "PARTNER",
      entityId: partnerId,
      otp,
    });
  },

  /**
   * Delete Partner using the existing delete API.
   * @param {{ partnerId: string|number, verificationToken?: string }} params
   */
  async deletePartner({ partnerId, verificationToken }) {
    void verificationToken;
    return deleteRequest(userServiceApi.deletePartner(partnerId));
  },
};

export default partnerDeleteService;
